import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { PlusButton } from '../ui/PlusButton';
import { navItems } from '../../data/navigation';
export function Navbar() {
  const {
    pathname
  } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => setOpen(false), [pathname]);
  const quoteProps = pathname === '/' ? {
    href: '#contact'
  } : {
    to: '/#contact'
  };
  return <header className={`fixed inset-x-0 top-0 z-50 border-b transition-colors duration-200 ${scrolled || open ? 'border-line bg-canvas/90 backdrop-blur-md' : 'border-line/70 bg-canvas'}`} data-id="element-323" data-mp="2y7aybh4dj8wg">
      <div className="shell flex h-[72px] items-center justify-between gap-6" data-id="element-324" data-mp="37nymsgosvt5o">
        <Link to="/" aria-label="Atelier Volta — accueil" className="shrink-0" data-id="element-325" data-mp="37lume8q41ca5">
          <Logo data-id="element-326" data-mp="32mrgkm2b3214" />
        </Link>

        <nav aria-label="Navigation principale" className="hidden items-center gap-9 lg:flex" data-id="element-327" data-mp="2xprioyfm15l3">
          {navItems.map(item => <NavLink key={item.path} to={item.path} className={({
          isActive
        }) => `group flex items-baseline gap-1.5 whitespace-nowrap text-[15px] transition-colors duration-150 ${isActive ? 'text-ink' : 'text-ink/75 hover:text-ink'}`} data-id="element-328" data-mp="2srg6wi5r8l08">
              {item.label}
              {item.soon && <span className="font-mono text-[10px] text-mute" data-id="element-329" data-mp="29yvmlp44fo81">à venir</span>}
            </NavLink>)}
        </nav>

        <div className="flex items-center gap-3" data-id="element-330" data-mp="251lw064zx6im">
          <PlusButton variant="ink" size="sm" className="hidden sm:inline-flex" {...quoteProps} data-id="element-331" data-mp="1vcoqr4yv2rjl">
            Demander un devis
          </PlusButton>
          <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'} className="flex h-10 w-10 items-center justify-center border border-line bg-paper lg:hidden" data-id="element-332" data-mp="20dm4n5cu8zfa">
            {open ? <XIcon className="h-5 w-5" data-id="element-333" data-mp="2j32am87alk33" /> : <MenuIcon className="h-5 w-5" data-id="element-334" data-mp="2j2alng87akls" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-335" data-mp="25amb3hdlo46x">
        {open && <motion.nav id="mobile-menu" aria-label="Navigation mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-line bg-canvas lg:hidden" data-id="element-336" data-mp="29czh86w9e448">
            <ul className="shell divide-y divide-line py-2" data-id="element-337" data-mp="qci6y2cbf7fr">
              {navItems.map(item => <li key={item.path} data-id="element-338" data-mp="ld5jbfdmdwc4">
                  <Link to={item.path} className="flex items-baseline justify-between py-4 text-xl font-medium" data-id="element-339" data-mp="103uuihr2zbfz">
                    {item.label}
                    {item.soon && <span className="font-mono text-xs text-mute" data-id="element-340" data-mp="v74iq6mb720d">à venir</span>}
                  </Link>
                </li>)}
              <li className="py-4" data-id="element-341" data-mp="2gvwa2kqpvfz">
                <PlusButton variant="ember" {...quoteProps} onClick={() => setOpen(false)} data-id="element-342" data-mp="2hx8wbhempzt">
                  Demander un devis
                </PlusButton>
              </li>
            </ul>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}